import { parseApiDateOnly, toDateOnlyMexicoCity } from './apiDateFormat'

const MEXICO_CITY_TZ = 'America/Mexico_City'

export const ISSUE_DATE_WINDOW_HOURS = 72
export const ISSUE_DATE_WINDOW_MESSAGE =
  'La fecha de emisión está fuera del límite permitido (máximo 72 horas hacia atrás desde la fecha y hora actuales). Corríjala antes de timbrar.'

function getCdmxParts(instant) {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone: MEXICO_CITY_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
  const map = {}
  dtf.formatToParts(instant).forEach((p) => {
    if (p.type !== 'literal') map[p.type] = parseInt(p.value, 10)
  })
  return map
}

function cdmxLocalToUtcMs(y, mo, d, h, mi, s) {
  for (let offsetH = 4; offsetH <= 8; offsetH += 1) {
    const ms = Date.UTC(y, mo - 1, d, h + offsetH, mi, s)
    const p = getCdmxParts(new Date(ms))
    if (p.year === y && p.month === mo && p.day === d && p.hour === h && p.minute === mi && p.second === s) {
      return ms
    }
  }
  for (let offsetH = 4; offsetH <= 8; offsetH += 1) {
    const ms = Date.UTC(y, mo - 1, d, h + offsetH, mi, 0)
    const p = getCdmxParts(new Date(ms))
    if (p.year === y && p.month === mo && p.day === d && p.hour === h && p.minute === mi) {
      return ms
    }
  }
  return Date.UTC(y, mo - 1, d, h + 6, mi, s)
}

export function isIssueDateWithinWindowMx(issueDateYmd, windowHours = ISSUE_DATE_WINDOW_HOURS, now = new Date()) {
  const parsed = parseApiDateOnly(issueDateYmd)
  if (!parsed) return false
  const ref = getCdmxParts(now)
  const issueMs = cdmxLocalToUtcMs(
    parsed.getFullYear(),
    parsed.getMonth() + 1,
    parsed.getDate(),
    ref.hour,
    ref.minute,
    ref.second
  )
  const nowMs = now.getTime()
  const minMs = nowMs - windowHours * 3600000
  return issueMs >= minMs && issueMs <= nowMs
}

export function getIssueDatePickerBoundsMx(windowHours = ISSUE_DATE_WINDOW_HOURS, now = new Date()) {
  const minMs = now.getTime() - windowHours * 3600000
  return {
    min: toDateOnlyMexicoCity(new Date(minMs)),
    // Honrar `now` tambien aqui: getTodayDateOnlyMx() lo ignoraba y tomaba el reloj
    // real, asi que min y max podian salir de relojes distintos si alguien inyectaba
    // una fecha. Sin llamador con argumentos hoy, el comportamiento no cambia.
    max: toDateOnlyMexicoCity(now),
  }
}
